var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupchatDroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1364",
    "data-name": "Rectangle 1364",
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_broadcast_icon",
    "data-name": "New broadcast icon",
    transform: "translate(0.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(-0.235)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M1.522,3.709A4.037,4.037,0,0,0,.838,6.1a4.183,4.183,0,0,0,.945,2.567",
    transform: "translate(-0.11 -1.184)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M3.879,1.5A3.662,3.662,0,0,1,5.893.934a3.764,3.764,0,0,1,2.591.834,4.584,4.584,0,0,1,1.564,2.457",
    transform: "translate(-1.081 -0.295)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M1.494,2.765S.556.733.788.75c.185.014,2.131.7,2.121.706",
    transform: "translate(-0.083 -0.239)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M1.564,16.75A4.037,4.037,0,0,1,.88,14.362a4.173,4.173,0,0,1,8.336-.2,4.244,4.244,0,0,1-1.1,3.149,4.222,4.222,0,0,1-3.148,1.324,3.664,3.664,0,0,1-2.014-.568",
    transform: "translate(-0.123 -3.275)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M1.537,19.791S.6,21.823.83,21.806c.185-.014,2.131-.7,2.121-.706",
    transform: "translate(-0.096 -6.316)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5135",
    "data-name": "Group 5135",
    transform: "translate(2.669 10.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M4.225,15.843a.5.5,0,0,1,.487.511.511.511,0,1,1-.487-.511",
    transform: "translate(-3.69 -15.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M7.022,15.843a.5.5,0,0,1,.487.511.511.511,0,1,1-.487-.511",
    transform: "translate(-4.583 -15.842)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M9.742,15.843a.5.5,0,0,1,.487.511.511.511,0,1,1-.487-.511",
    transform: "translate(-5.451 -15.842)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M10.367,9.025l.155-.854a4.216,4.216,0,0,1,3.9-3.331,4.4,4.4,0,0,1,2.149.505,3.806,3.806,0,0,1,1.466,1.283,4.576,4.576,0,0,1,.736,2.588,3.7,3.7,0,0,1-.616,2.006",
    transform: "translate(-3.152 -1.544)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M17.843,16.207a4.007,4.007,0,0,1-2.4.627,4.154,4.154,0,0,1-1.838-.524",
    transform: "translate(-4.186 -5.172)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M19.828,15.558s2,.993,1.989.759c-.009-.186-.649-2.156-.65-2.145",
    transform: "translate(-6.171 -4.523)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M16.91,9.935H15.287a.511.511,0,0,1,0-1.021H16.91a.511.511,0,0,1,0,1.021",
    transform: "translate(-4.559 -2.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M16.91,12.693H15.287a.511.511,0,0,1,0-1.021H16.91a.511.511,0,0,1,0,1.021",
    transform: "translate(-4.559 -3.725)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupchatDroupIcon);
export default __webpack_public_path__ + "static/media/groupchat-droup-icon.d4855efa3f41327e0c1d46ed66b62511.svg";
export { ForwardRef as ReactComponent };